import { useEffect, useRef, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import UserOne from '../../assets/images/user/user-02.png';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '@/store';
import { useLogoutMutation } from '@/services/auth.service';
import { removeAuth } from '@/store/features/auth.slice';

export default function DropdownUser() {
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const location = useLocation()
    const {t} = useTranslation()
    const navigate = useNavigate()
    const dispatch = useDispatch<AppDispatch>()
    const [logout, { isSuccess }] = useLogoutMutation()
    const { auth } = useSelector((state: RootState) => state.auth)

    const trigger = useRef<any>(null);
    const dropdown = useRef<any>(null);

    // close on click outside
    useEffect(() => {
        const clickHandler = ({ target }: MouseEvent) => {
            if (!dropdown.current) return;
            if (
                !dropdownOpen ||
                dropdown.current.contains(target) ||
                trigger.current.contains(target)
            )
                return;
            setDropdownOpen(false);
        };
        document.addEventListener('click', clickHandler);
        return () => document.removeEventListener('click', clickHandler);
    });

    useEffect(() => {
        if(isSuccess) {
            dispatch(removeAuth())
            navigate("/login")
        }
    }, [isSuccess])

    return (
        <div className="relative">
            <Link
                ref={trigger}
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="flex items-center gap-4"
                to="#"
            >
                <span className="hidden text-right md:block">
                    <span className="block text-sm font-medium text-black dark:text-white">
                        {auth?.name}
                    </span>
                </span>

                <span className="h-8 w-8 rounded-full">
                    <img src={UserOne} alt="User" />
                </span>

                <i className={`fa-regular fa-chevron-down hidden fill-current sm:block ${dropdownOpen ? 'fa-rotate-180' : ''
                }`} />
            </Link>

            {/* <!-- Dropdown Start --> */}
            <div
                ref={dropdown}
                onFocus={() => setDropdownOpen(true)}
                onBlur={() => setDropdownOpen(false)}
                className={`absolute right-0 mt-4 w-62.5 rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark ${dropdownOpen === true ? 'block' : 'hidden'}`}
            >
                <ul className="flex flex-col gap-5 border-b border-stroke px-6 py-4 dark:border-strokedark">
                    <li className="cursor-pointer" onClick={() => navigate(location , {state: {modal: "/profile"}})}>
                        <span
                            className="flex items-center gap-3.5 text-sm duration-300 ease-in-out hover:text-primary"
                        >
                            <i className="fa-light fa-user" />
                            {t("profile.profile")}
                        </span>
                    </li>
                </ul>
                <button className="flex items-center gap-3.5 py-4 px-6 text-sm duration-300 ease-in-out hover:text-primary" onClick={logout}>
                    <i className="fa-light fa-arrow-right-from-bracket fa-rotate-180" />
                    {t("profile.logout")}
                </button>
            </div>
            {/* <!-- Dropdown End --> */}
        </div>
    );
};
